module.exports = __webpack_public_path__ + "img/feedback_2.6b2ff540.png";